const MAX_REPORTS_PER_SESSION = 5;

export class ErrorReporter {
  constructor(apiBase, appVersion, fetcher = (...args) => fetch(...args)) {
    this.apiBase = apiBase;
    this.appVersion = appVersion;
    this.fetcher = fetcher;
    this.sent = 0;
    this.seen = new Set();
  }

  install(target = window) {
    target.addEventListener("error", (event) => this.report(event.error || event.message, "window.error"));
    target.addEventListener("unhandledrejection", (event) => this.report(event.reason, "unhandledrejection"));
  }

  format(error, where) {
    const message = error instanceof Error ? error.message : String(error);
    const stack = error instanceof Error && error.stack ? error.stack.split("\n").slice(0, 8).join("\n") : "";
    return { where, message: message.slice(0, 500), stack: stack.slice(0, 2000), app_version: this.appVersion,
      url: location.pathname + location.hash, user_agent: navigator.userAgent.slice(0, 200) };
  }

  report(error, where = "app") {
    console.error(`[PAWS] ${where}`, error);
    if (!this.apiBase || this.sent >= MAX_REPORTS_PER_SESSION) return false;
    const payload = this.format(error, where);
    const key = `${payload.where}:${payload.message}`;
    if (this.seen.has(key)) return false;
    this.seen.add(key);
    this.sent += 1;
    this.fetcher(`${this.apiBase}/api/client-error`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(() => {});
    return true;
  }
}
